var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c("div", { staticClass: "breadcrumb" }, [
                    _vm._v(" Kortingcodes "),
                  ]),
                  _c("w-spacer"),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.add()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: _vm.editDisabled },
                          on: {
                            click: function ($event) {
                              return _vm.edit()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "pen" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: _vm.removeDisabled },
                          on: {
                            click: function ($event) {
                              return _vm.remove()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: {
                  "flex-grow": "1",
                  height: "calc(100vh - 185px)",
                },
                attrs: {
                  items: _vm.codes,
                  columns: _vm.columns,
                  "order-column": _vm.orderColumn,
                  "selected-items": _vm.selectedItems,
                  "order-direction": _vm.orderDirection,
                },
                on: {
                  order: function ($event) {
                    return _vm.onOrder($event)
                  },
                  "item-clicked": function ($event) {
                    return _vm.onButtonClickShowInfo($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                [
                  _c("w-select", {
                    attrs: { items: _vm.limits, up: true },
                    model: {
                      value: _vm.limit,
                      callback: function ($$v) {
                        _vm.limit = $$v
                      },
                      expression: "limit",
                    },
                  }),
                  _c(
                    "w-col",
                    {
                      staticClass: "amountShown",
                      attrs: { xs: "6", md: "3", lg: "1" },
                    },
                    [
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.showTotalRecordsText) + " "),
                      ]),
                    ]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6", lg: "4" } },
                    [
                      _c(
                        "w-row",
                        [
                          _c("w-spacer"),
                          _c("w-pagination", {
                            attrs: {
                              value: _vm.page,
                              "max-shown-pages": 5,
                              "total-pages": _vm.pageCount,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setPage($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }